<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.spcode" placeholder="编号" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.name" placeholder="名称" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.web_path" placeholder="同步接口" @keyup.enter.native="getLists"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="getLists">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="datalist" border stripe highlight-current-row v-loading="listLoading" style="width:90%;" height="600">
			<el-table-column prop="entime" label="时间" min-width="100"></el-table-column>
			<el-table-column prop="spcode" label="编号" min-width="100"></el-table-column>
			<el-table-column prop="name" label="名称" min-width="100"></el-table-column>
			<el-table-column prop="web_path" label="同步接口" min-width="100"></el-table-column>
			<el-table-column prop="dataconf" label="配置" min-width="100"></el-table-column>
			<el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
			<el-table-column label="操作" fixed="right" width="100">
				<template slot-scope="scope">
					<div>
						<el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
						<el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
		<!--工具条翻页-->
		<el-col :span="24" class="toolbar">
		<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="pagesize" :total="total" style="float:right;"></el-pagination>
		</el-col>
		<el-drawer
		  :title="editformtitle"
		  :visible.sync="editFormVisible" :before-close="onClickClose"
		  size="50%" :with-header="false"
		  direction="rtl">
			<el-form :model="editForm" label-width="100px" :rules="formRules" ref="editForm">
			<el-container>
				<el-header>
					<el-button @click.native="editFormVisible = false">取消</el-button>
					<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
				</el-header>
				<el-main>
					<el-form-item label="编号" prop="spcode">
						<el-input v-model="editForm.spcode" placeholder="编号" @blur="inputExtend"></el-input>
						<el-tag effect="dark" v-if="checkInSpService" type="danger">存在此代码请更改!</tag>
					</el-form-item>
					<el-form-item label="名称" prop="name">
						<el-input v-model="editForm.name" placeholder="名称"></el-input>
					</el-form-item>
					<el-form-item label="同步接口" prop="web_path">
						<el-input v-model="editForm.web_path" placeholder="同步接口"></el-input>
					</el-form-item>
					<el-form-item label="配置" prop="dataconf">
						<el-input v-model="editForm.dataconf" placeholder="配置" type="textarea" :autosize="{ minRows: 4, maxRows: 25}"></el-input>
					</el-form-item>
					<el-form-item label="备注" prop="remark">
						<el-input v-model="editForm.remark" placeholder="备注" type="textarea" :autosize="{ minRows: 4, maxRows: 25}"></el-input>
					</el-form-item>
				</el-main>
			</el-container>
			</el-form>
		</el-drawer>
	</section>
</template>
<script>
	import util from '../../common/js/util'
	import { getListPage, delData, saveData } from '../../api/api';
	export default {
		data() {
			return {
				filters:{
					spcode:'',name:'',web_path:''
				},
				checkInSpService:false,
				datalist: [],
				total: 0,
				pagesize:20,
				page: 1,
				listLoading: false,
				/////////////Form 表单
				editformtitle:'',//form编辑名称
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				formRules: {
					spcode :[
						{required: true,message: '编号不能为空!',trigger: 'blur'}
					],
					name :[
						{required: true,message: '名称不能为空!',trigger: 'blur'}
					],
					web_path :[
						{required: true,message: '同步接口不能为空!',trigger: 'blur'}
					],
				},
				//编辑界面数据
				editForm: {
					actionurl:'',sqlid:'',entime:'',spcode:'',name:'',web_path:'',dataconf:'',remark:''
				}
			}
		},
		methods: {
			inputExtend(){
				if(this.editForm.spcode=='') return ;
				this.editLoading = true ;
				//检测代码是否存在
				let para = {
					actionurl:'default/getListAll',
					spcode:this.editForm.spcode,
					checkId:this.editForm.id,
					sqlid:'sp_spinfo.checkQuery'
				};
			
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						if(res.data.total>0) this.checkInSpService = true ;//存在
						else this.checkInSpService = false ;
					}
					this.editLoading = false;
				});
			},
			onClickClose:function(){},
			getLists:function(){
				let para = {
					page: this.page,
					pagesize:this.pagesize,
					actionurl:'default/getList',
					spcode:this.filters.spcode,
					name:this.filters.name,
					web_path:this.filters.web_path,
					sqlid:'sp_spinfo.query'
				};
				this.listLoading = true;
				getListPage(para).then((res) => {
					if(!util.checkLogOut(this,res.data)){
						this.total = res.data.total;
						this.datalist = res.data.datas;
					}
					this.listLoading = false;
				});
			},
			handleAdd:function(){
				this.editFormVisible = true;
				this.editformtitle = '新增';
				this.editForm = {
					actionurl:'default/save',sqlid:'sp_spinfo.add',entime:'',spcode:'',name:'',web_path:'',dataconf:'',remark:''
				};
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;
				this.editformtitle = '编辑';
				this.editForm = Object.assign({}, row);
				this.editForm.actionurl = 'default/save';//设置Sqlid
				this.editForm.sqlid = 'sp_spinfo.upt';
			},
			editSubmit:function(){
				if(this.checkInSpService) {
					this.$message({message: "代码重复，不可提交!",type: "error"});
					return ;
				}
				let para = Object.assign({}, this.editForm);
				util.saveFunction(this,para);
			},
			handleDel: function (index, row) {
				//检测
				this.$confirm('确认删除该记录吗?', '提示', {type: 'warning'}).then(() => {
					let para = {
						actionurl:'default/getListAll',
						spcode:row.spcode,
						sqlid:'sp_spConf.query'
					};
					getListPage(para).then((res) => {
						if(!util.checkLogOut(this,res.data)){
							if(res.data.total>0) {
								this.$message({message: "此上游被业务代码使用，暂不可删除!",type: "error"});
							}
							else {
								this.$message({message: "检测到此上游未被使用，正在删除中!",type: "success"});
								this.listLoading = true;
								let para = {
									actionurl:'default/del',
									sqlid:'sp_spinfo.del',
									id:row.id
								};
								delData(para).then((res) => {
									this.listLoading = false;
									this.$message({message: res.data.message,type: res.data.type});
									this.getLists();
								});
							}
						}
						this.editLoading = false;
					});
				}).catch(() => {});
				
			}
		},
		mounted() {
			this.getLists();
		}
	}	
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// spinfo.vue?fbbf9c1c